import { z } from 'zod';

export const LoanPointOfContactApi = z.object({
  loanId: z.string(),
  losId: z.string(),
  email: z.string().optional().describe('No point of contact is assigned to the loan if the email address is empty'),
});
export type LoanPointOfContactApi = z.infer<typeof LoanPointOfContactApi>;

export const LoanPointOfContactSpecialistApi = z.object({
  loanId: z.string(),
  losId: z.string(),
  specialists: z.array(
    z.object({
      roleId: z.string(),
      title: z.string(),
      key: z.string(),
      email: z.string().optional(),
    }),
  ),
});
export type LoanPointOfContactSpecialistApi = z.infer<typeof LoanPointOfContactSpecialistApi>;
